<template>
    <div class="modal-container has-text-centered">
         <div class="delete is-large is-pulled-right" @click="$emit('close')"></div>
        <div class="has-background-dark pad10"> <div class="is-size-4"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3 has-text-white"> ADD CONNECTION</span></div></div>
        <div>&nbsp;</div>

        <div>
            <div>We will send an email invitation to connect on your behalf. If this email address belongs to an existing user, we will also send this user an internal notification.</div>
            <!-- <textarea ref="ta" rows="6" class="top10">The message goes here...</textarea><br> -->
            <button id="pubButt" class="button is-coolGreen is-small top20" @click="send">SEND</button>&nbsp;<button class="button top20 is-small" @click="$emit('close')">CANCEL</button>
        </div>

        <div>&nbsp;</div>
    </div>
</template>

<script>

export default{
    name: 'modalconnectsinvite',
    props: ['callback'],

    data: function(){
        return {

        }
    }, 

    methods: {
        send: function(){
            az.addRemSpinner(true, 'id', 'pubButt')
            this.callback()
        }
    }
}

</script>

<style scoped>
    .modal-container{
        max-width: 450px !important
    }

</style>